// Inicio: oscurece el header al hacer scroll y escribe el título del hero letra por letra
(function () {
  var body = document.body;

  function onScroll() {
    body.classList.toggle("is-scrolled", window.scrollY > 40);
  }
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  // El tema agrega "color-background-1" al header al pasar el mouse (se vuelve blanco): en el inicio se evita
  var headerSection = document.querySelector(".shopify-section-header");
  if (headerSection) {
    var stripLight = function () {
      if (headerSection.classList.contains("color-background-1")) {
        headerSection.classList.remove("color-background-1");
      }
    };
    stripLight();
    new MutationObserver(stripLight).observe(headerSection, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  var title = document.querySelector(".slideshow-slide__title");
  if (!title || title.dataset.introReady) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    title.dataset.introReady = "true";
    return;
  }

  var text = title.textContent.trim();
  title.dataset.introReady = "true";
  title.setAttribute("aria-label", text);
  title.textContent = "";

  var index = 0;
  text.split(/\s+/).forEach(function (word, w, words) {
    var wordEl = document.createElement("span");
    wordEl.className = "intro-word";
    wordEl.setAttribute("aria-hidden", "true");
    word.split("").forEach(function (char) {
      var letter = document.createElement("span");
      letter.className = "intro-letter";
      letter.style.setProperty("--i", index++);
      letter.textContent = char;
      wordEl.appendChild(letter);
    });
    title.appendChild(wordEl);
    if (w < words.length - 1) title.appendChild(document.createTextNode(" "));
  });

  // El resto del contenido aparece cuando termina de escribirse
  var typingEnd = 1.1 + index * 0.075;
  document.documentElement.style.setProperty(
    "--intro-after",
    (typingEnd + 0.3).toFixed(2) + "s"
  );
})();
